<ng-container [formGroup]="parent">
  <jni-ship-to-address
    #shipTo
    [parent]="parent"
    [deliveryAddress]="deliveryAddress"
    [countryRegionList]="countryRegionList"
    (smallLoaderEvent)="getLoaderStatus($event)"
    [showAddress]="showAddress"
    [shiftToAddressList]="customerList"
    [formgroupName]="'shipTo'"
    [formErrors]="formErrors"
    (validationErrorEvent)="logValidationErrors()"
    [shipToAddress]="shipToAddress"
    [vendorAccountAndBook]="vendorAccountAndBook"
    [addressObject]="addressObject"
    [headerObject]="headerObject"
    [clientShipToAddressDisabled]="clientShipToAddressDisabled"
    [vendorNameShipToAddressDisabled]="vendorNameShipToAddressDisabled"
    (multiShipToAndTbdEvent)="patchValueInMultiShipToAndTbd($event)"
    [isEditFromCdi]="isEditFromCdi"
    (melissaValidationIgnoreEvent)="handleMelissaValidationIgnore($event)"
    (melissaAddressValidatedEvent)="melissaAddressValidatedEvent($event)"
    [isShipToAddressFromOrder]="true"
    [fromAddressAssignment]="fromAddressAssignment"
    [defaultOneTime]="defaultOneTime"
    [collapseStatus]="collapseStatus">
  </jni-ship-to-address>
</ng-container>
